module.exports = __webpack_public_path__ + "images/1b5e2828.jpg";